module.exports = __webpack_public_path__ + "static/integration/img/ally-icon-indicator-perfect-learnUltra.cd4d0bf4d0103256abd2ba724792290f.svg";